import styled from "styled-components";
import { BLUE } from "@root/common";

const UpperInfoStyled = styled.div`
    position: relative;
    height: 50%;
    width: 100%;
    padding: 2.5%;
    padding-top: 0;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 5%;
`

const TitlesContainer = styled.div`
    height: calc(100% / 2);
    position: relative;
    width: 100%;
    
    display: flex;
    flex-direction: row;
    align-items: end;
    justify-content: start;
    gap: 0 10%;
`

const InfoSettings = styled.div`
  width: 45%;
  height: fit-content;

  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 8px;

  p {
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: relative;

    input {
        width: calc(100% - 6em);
        border-radius: 8px;
        outline: none;

        margin-left: 1em;
        padding: 6px;

        &:focus {
            border: 1px solid black;
        }

        appearance: none;
        margin: 0;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* for firefox */
    input[type=number]{
      -moz-appearance: textfield;
    }
  }
`

const Info = styled.div`
  height: calc(100% * 2 / 3);

  padding: 1em;
  border: 1px solid;
  border-radius: 1em;
  width: fit-content;
  min-width: calc(45% * 2 / 3);

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  p {
    white-space: nowrap;
  }
`

const LongShortContainer = styled.div`
    height: calc(100% / 2);
    width: 100%;

    display: flex;
    flex-direction: row;
    gap: 0 10%;
    flex-wrap: wrap;

    div {
        width: 45%;
        height: 100%;
        padding: 5px 1em;
        border: 1px solid black;
        border-radius: 1em;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        a {
            color: ${BLUE};
            text-decoration: none;
            font-size: 1.2em;
        }

        p {
            width: 100%;
            text-align: start;
        }
    }
`

export {UpperInfoStyled, TitlesContainer, LongShortContainer, InfoSettings, Info}